module.exports = __webpack_public_path__ + "img/swiper9.98918a26.png";